export default __webpack_public_path__ + "search-icon.svg";